import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCAE9GyWbLvaeWSqxo4lHrK65Xex67kBqw",
  authDomain: "punjabiboli.firebaseapp.com",
  projectId: "punjabiboli",
  storageBucket: "punjabiboli.appspot.com",
  messagingSenderId: "642819202730",
  appId: "1:642819202730:web:1e1ffbd6071764ee82fad3"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const db = getFirestore(app);
